import request from '@/utils/axios'

// 获取聊天记录
export function getMessageCode(code) {
 return request({
  url: `/v1/send/message/detail`,
  method: 'GET',
  params: { code }
 })
}
